import React from 'react';

const ContainerDiv = ({className, children, container = true}) => {
    return container ? <div className={className}>{children}</div> : children;
}
export default ContainerDiv